import React, { FC, useEffect, useMemo } from 'react'
import { fetchAlarmSeverityReferenceData, fetchChargerLocationReferenceData, fetchChargerModelReferenceData, fetchChargerStationReferenceData, fetchChargerStatusReferenceData,fetchChargerProductTypeReferenceData ,fetchChargerTypeReferenceData, fetchCustomerReferenceData, fetchRegionReferenceData, fetchSoftwarVersionReferenceData,fetchAlarmTypeReferenceData,fetchChargerVisibleIdReferenceData,getReferenceDataReducer, getFilterSelectedValue, getFilterReducer,fetchUsersReferenceData,fetchParametersReferenceData, fetchOrgReferenceData, fetchChargerVisibilityReferenceData,fetchExceptionLogsSeverityReferenceData, fetchAlarmRules, fetchAlarmTypeOfNotification, fetchConfigureNotificationHistoryRuleIdReferenceData, fetchChargerRuleEngineTriggerCategoryReferenceData, fetchChargerRuleEngineActionControlReferenceData, fetchChargerRuleEngineScheduleReferenceData, fetchChargerRuleEngineTriggerLevelReferenceData, fetchChargerRuleEngineStatusReferenceData, fetchChargerRuleEngineRuleNameReferenceData} from '../../rmsReduxStore/reduxExports'
import SelectDropDown, { CustomDropdownPropTypes } from '../../globalUtils/SelectDropDown/SelectDropDown'
import { useAppDispatch, useAppSelector } from '../../globalUtils/globalExports'
import CustomDatePicker, { CustomDatePickerProps } from '../../globalUtils/CustomDatePicker/CustomDatePicker'
import { fetchAlarmRuleSeverityReferenceData, fetchAlarmStatusReferenceData, fetchChargerActiveCertificateReferenceData, fetchStopReasonCodeReferenceData, fetchVersionClassificationReferenceData, fetchVersionProductTypeReferenceData, fetchVersionSeverityReferenceData } from '../../rmsReduxStore/referenceDataRedux/referenceDataCreators'
// import { cloneDeep } from 'lodash'
import { Menu,MenuItem } from '@mui/material';
import './CustomFilterLayout.css';
import { Icon } from '../../globalUtils/globalIcons'
import AsyncSelectDropDown, { AsyncSelectDropDownProps } from '../../globalUtils/AsyncSelectDropDown/AsyncSelectDropDown'

export interface CustomFilterProp {
  filterId: string
  filterLabel: string
  filterType: 'dropdown' | 'dateFilter' | 'asyncDropdown'
  filterDropdownProps?: CustomDropdownPropTypes | null,
  asyncDropdownProps?: AsyncSelectDropDownProps | null,
  dateFilterProps?: CustomDatePickerProps | null
  width?: string
}

interface CustomFilterLayoutProps {
  screen?:string
  filters: CustomFilterProp[],
  excludeGlobalFilters?: boolean,
  filterAnchorEl:HTMLElement | null,
  setFilterAnchorEl:React.Dispatch<React.SetStateAction<HTMLElement | null>>,
  requiredReferenceDataCallbacks: ('customer' | 'severity' | 'chargerModel' | 'location' | 'status' | 'chargerType' | 'region' | 'softwareVersion' | 'chargingStation' | 'alarmType' | 'chargerVisibleId' | 'parameterName' | 'user' | 'editHistory' | 'orgName' | 'visibility' | 'chargingStationId'|'productType'|'alarmTypeId'|'typeOfNotification'| 'stopReasonCode' | 'ruleId' | 'alarmSeverity' |'activeCertificate' |'userRemoteCommand')[] | string[];
  // eslint-disable-next-line @typescript-eslint/ban-types
  handleFilterDataChange?:Function;
}

export const referenceDataCallBackMapper = [
  {
    key: 'customer',
    referenceDataCallBack: fetchCustomerReferenceData
  },
  {
    key: 'severity',
    referenceDataCallBack: fetchAlarmSeverityReferenceData
  },
  {
    key: 'chargerModel',
    referenceDataCallBack: fetchChargerModelReferenceData
  },
  {
    key: 'location',
    referenceDataCallBack: fetchChargerLocationReferenceData
  },
  {
    key: 'status',
    referenceDataCallBack: fetchChargerStatusReferenceData
  },
  {
    key: 'productType',
    referenceDataCallBack: fetchChargerProductTypeReferenceData
  },
  {
    key: 'activeCertificate',
    referenceDataCallBack: fetchChargerActiveCertificateReferenceData
  },
  {
    key: 'chargerType',
    referenceDataCallBack: fetchChargerTypeReferenceData
  },
  {
    key: 'region',
    referenceDataCallBack: fetchRegionReferenceData
  },
  {
    key: 'softwareVersion',
    referenceDataCallBack: fetchSoftwarVersionReferenceData
  },
  {
    key: 'chargingStation',
    referenceDataCallBack: fetchChargerStationReferenceData
  },
  {
    key: 'alarmType',
    referenceDataCallBack: fetchAlarmTypeReferenceData
  },
  {
    key : 'chargerVisibleId',
    referenceDataCallBack: fetchChargerVisibleIdReferenceData
  },
  {
    key : 'parameterName',
    referenceDataCallBack: fetchParametersReferenceData
  },
  {
    key : 'user',
    referenceDataCallBack: fetchUsersReferenceData
  },
  {
    key : 'orgName',
    referenceDataCallBack: fetchOrgReferenceData
  },
  {
     key:'visibility',
     referenceDataCallBack:fetchChargerVisibilityReferenceData
  },
  {
      key:'chargingStationId',
      referenceDataCallBack:fetchChargerStationReferenceData
  },
  {
      key:'logSeverity',
      referenceDataCallBack:fetchExceptionLogsSeverityReferenceData
 },
 {
      key:'alarmTypeId',
      referenceDataCallBack:fetchAlarmRules 
 },
 {
      key:'typeOfNotification',
      referenceDataCallBack:fetchAlarmTypeOfNotification
 },
 {
      key:'stopReasonCode',
      referenceDataCallBack:fetchStopReasonCodeReferenceData  
  },
 {
      key:'ruleId',
      referenceDataCallBack: fetchConfigureNotificationHistoryRuleIdReferenceData
 },

  {
    key: 'triggerCategory',
    referenceDataCallBack: fetchChargerRuleEngineTriggerCategoryReferenceData
  },
  {
    key: 'triggerLevel',
    referenceDataCallBack: fetchChargerRuleEngineTriggerLevelReferenceData
  },
  {
    key: 'actionControls',
    referenceDataCallBack: fetchChargerRuleEngineActionControlReferenceData
  },
  {
    key: 'schedule',
    referenceDataCallBack: fetchChargerRuleEngineScheduleReferenceData
  },
  {
    key:'ruleEngineChipStatus',
    referenceDataCallBack: fetchChargerRuleEngineStatusReferenceData
  },
  {
    key:'ruleEngineRuleName',
    referenceDataCallBack:fetchChargerRuleEngineRuleNameReferenceData
  },
  {
    key: 'alarmSeverity',
    referenceDataCallBack: fetchAlarmRuleSeverityReferenceData // change the function 
  } ,
  {
    key:'logSeverity',
    referenceDataCallBack:fetchExceptionLogsSeverityReferenceData
  },
  {
    key:'userRemoteCommand',
    referenceDataCallBack:fetchUsersReferenceData
  },
  {
    key: 'productType',
    referenceDataCallBack: fetchChargerProductTypeReferenceData
  },
  {
    key: 'versionSeverity',
    referenceDataCallBack:fetchVersionSeverityReferenceData
  },
  {
    key: 'versionClassification',
    referenceDataCallBack: fetchVersionClassificationReferenceData
  }
,
  {
    key: 'versionProductType',
    referenceDataCallBack: fetchVersionProductTypeReferenceData
  }
  ,
  {
    key:'alarmState',
    referenceDataCallBack: fetchAlarmStatusReferenceData
  }
]

const CustomFilterLayout: FC<CustomFilterLayoutProps> = (props) => {
  const {screen, filters, requiredReferenceDataCallbacks,handleFilterDataChange, excludeGlobalFilters,filterAnchorEl,setFilterAnchorEl } = props;
  const dispatch = useAppDispatch()
  const {customerReferenceData } = useAppSelector(getReferenceDataReducer);
  const {globalFilters} = useAppSelector(getFilterReducer)

  useEffect(() => {
    if (requiredReferenceDataCallbacks && requiredReferenceDataCallbacks?.length > 0) {
      // Adding Global filters callBacks key to coming callBacks keys props...
      const referenceDataCallBacks = requiredReferenceDataCallbacks.concat(['customer'])
      referenceDataCallBacks?.forEach(type => {
        const callbackItem = referenceDataCallBackMapper?.find(item => item?.key === type);
        if (callbackItem) {
          if ((screen === 'charging_history' || screen === 'alarms') && type === 'chargerVisibleId') {
            const selectedCustomerFilter = getFilterSelectedValue('customer','global',true)
            const reqBody = {
              customerIds : selectedCustomerFilter?.filter((item) => item?.id === 'all')?.length > 0  ? ['all'] : selectedCustomerFilter?.map((customer) => customer?.id)
            }
            dispatch(callbackItem?.referenceDataCallBack(reqBody))
          } else {
            dispatch(callbackItem?.referenceDataCallBack())
          }
        }
      })
    } else {
      dispatch(fetchCustomerReferenceData())
    }
  }, [])


  const globalFiltersProps: CustomFilterProp[] = useMemo(() => {
    return [
      {
        filterLabel: screen === 'newDashboard' ? 'Customer' : 'Customers',
        filterType: 'dropdown',
        filterId: 'Customer',
        filterDropdownProps: {
          selectValue: getFilterSelectedValue('customer','global',true),
          selectOptions: customerReferenceData ?? [],
          handleSelectOptionChange: (val): void => {
            handleFilterDataChange?.(val, 'customer',true)
          },
          selectDropDownId: 'charger-customer-filter-dropdown',
          isMultiSelect: true,
          renderToBody: true
        }
      },
    ]
    
  }, [ customerReferenceData,globalFilters])



  const allFilters = excludeGlobalFilters? [...filters] : [...globalFiltersProps,...filters]

  return (
    <Menu
        id='custom-filters-dropdown'
        anchorEl={filterAnchorEl}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        className='custom__filters__dropdown__container'
        sx={{ top: '30px' }}
        open={Boolean(filterAnchorEl)}
        onClose={()=>{setFilterAnchorEl(null)}}
        slotProps={{
            paper: {
                sx: {
                minWidth: '200px',
            },
        },
        }}
    >
    <div className='custom-filters-dropdown-header'>
        <div className='custom-filters-dropdown-header-heading'>Add Filters</div>
        <div className='custom-filters-dropdown-header-close-btn'>
            <Icon iconClassName='react__select__dropdown__cross__icon' onIconClick={()=>{setFilterAnchorEl(null)}}/>
        </div>
    </div>
    <div className='custom-filters-dropdown-body'>
        {
        allFilters && allFilters?.length > 0 && allFilters?.map((filter, index) => {
      return (
        <MenuItem key={index} 
            disableRipple
            sx={{
            '&:hover': {backgroundColor: 'transparent'},
            '&.Mui-selected': { backgroundColor: 'transparent' }, // selected
            '&.Mui-focusVisible': { backgroundColor: 'transparent' }, 
            cursor:'default'
        }}
        onKeyDown={(e)=>{e.stopPropagation()}} //stops event propagation to parent.
        >
            <div className="custom__filter__wrap-content-row" style={{width:'200px'}}>
          <div className="custom__filter__wrap-content-row-label">{filter?.filterLabel}</div>
          <div className="custom__filter__wrap-content_filter">
            {filter.filterType === 'dropdown' && filter?.filterDropdownProps &&
              <SelectDropDown
                selectValue={filter?.filterDropdownProps?.selectValue}
                selectOptions={filter?.filterDropdownProps?.selectOptions ?? []}
                handleSelectOptionChange={filter?.filterDropdownProps?.handleSelectOptionChange}
                selectDropDownId={filter?.filterDropdownProps?.selectDropDownId}
                isMultiSelect={filter?.filterDropdownProps?.isMultiSelect}
                renderToBody={filter?.filterDropdownProps?.renderToBody}
                menuPlacement={filter?.filterDropdownProps?.menuPlacement}
                // renderToBody={true}
              />
            }
            {
              filter.filterType === 'asyncDropdown' && filter.asyncDropdownProps &&
              <AsyncSelectDropDown {...filter.asyncDropdownProps} />
            }
            {filter.filterType === 'dateFilter' && filter?.dateFilterProps &&
              <CustomDatePicker startDate={filter?.dateFilterProps?.startDate ? new Date(filter?.dateFilterProps?.startDate) : null} endDate={filter?.dateFilterProps?.endDate ? new Date(filter?.dateFilterProps?.endDate) : null} selectsRange={filter?.dateFilterProps?.selectsRange} onChange={filter?.dateFilterProps?.onChange} includeDateIntervals={filter?.dateFilterProps.includeDateIntervals} />}
          </div>
        </div>

        </MenuItem>
      )
    }
    )
    }
    </div>
    </Menu>
    )
}

export default CustomFilterLayout